import {HeaderTitle, Breadcrumb} from '@/components/atoms'
import {TabsComponent} from '@/components/molecules'
import { OrderInfo, OrderPriceInfo, OrderSoldTo, OrderRewards, OnlineItemsList} from '@/containers'
import { useOrderOnlineDetails } from '../useOrderOverview'
import OrderDigitalPaymentPage from '@/containers/OrderContainer/OrderDetails/OrderDigitalPayment/OrderDigitalPayment'
import './_orderDetail.scss'
import { Tag } from "pepsico-ds";
import { orderType } from '@/utils/constants/commonConstants'
import { capitalizeWords } from '@/utils/commons';
import { TableSkeletonLoader } from '@/components/atoms';

const getColorTag = status => {
 const statusLower = status?.toLocaleLowerCase()
 if (statusLower === 'completed' || statusLower === 'partially_delivered' || statusLower === 'delivered') {
   return 'completed-tag'
 } else if (statusLower === 'cancelled') {
   return 'cancelled-tag'
 } else {
   return 'default-tag'
 }
}


export const OrderDetail = () => {
  const {orderOverviewData, isLoading} = useOrderOnlineDetails()

  const updatedStatus = orderOverviewData?.orderState;
  const TabList = [
    {
      tabLabel: 'Order Information',
      id: '1',
      tabComponent: <OrderInfo OrderDetails={orderOverviewData} />,
    },
    {
      tabLabel: 'Items',
      id: '2',
      tabComponent: <OnlineItemsList OrderDetail={orderOverviewData?.items} orderType={orderType.ONLINE} orderId={orderOverviewData} />,
    },
    {
      tabLabel: 'Price Information',
      id: '3',
      tabComponent: <OrderPriceInfo OrderDetails={orderOverviewData} />,
    },
    {
      tabLabel: 'Sold To',
      id: '4',
      tabComponent: <OrderSoldTo OrderDetails={orderOverviewData} />,
    },
    {
      tabLabel: 'Digital Payment',
      id: '5',
      tabComponent: <OrderDigitalPaymentPage orderDetails={orderOverviewData} />,
    },
    {
      tabLabel: 'Rewards',
      id: '6',
      tabComponent: <OrderRewards rewardsDetails={orderOverviewData} />,
    },
  ]
  
  return (
    <>
      {isLoading ? (
        <TableSkeletonLoader rows={10} rowHeight={30} spacing={20} />
      ) : (
        <>
          <div className="OrderDetail flex flex-row justify-between">
            <Breadcrumb
              uiSchema={{
                isDark: true,
                className: 'mb-5',
                breadcrumbs: [
                  {
                    href: '/',
                    label: 'Home',
                  },
                  {
                    href: '/orders/list?type=online',
                    label: 'Online Order',
                  },
                  {
                    label: orderOverviewData?.orderId,
                  },
                ],
              }}
              id={'od_bradcrumb'}
            />
          </div>

          <div className="mb-6 mt-6 flex flex-row gap-4 items-center">
            <HeaderTitle title={`${orderOverviewData?.orderId}`} className="header-title justify-start text-3xl font-bold" />
            <Tag text={capitalizeWords(updatedStatus)} className={getColorTag(updatedStatus)} isCopyable={false} />
          </div>
          <TabsComponent tabList={TabList} defaultTabIndex={0} removeBG={true} />
        </>
      )}
    </>
  )
};
